import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/audio-recording-item/audio-recording-item.js';
      import {AudioRecordingStatus} from '@oicl/openbridge-webcomponents/dist/components/audio-recording-item/audio-recording-item.js';

      export interface Props {
     audioLevels?: number[];
     duration?: number;
     status?: AudioRecordingStatus;
     playbackPosition?: number;
     isPlaying?: boolean;
     enhanced?: boolean
   }

      
  
      export type {AudioRecordingStatus} from '@oicl/openbridge-webcomponents/dist/components/audio-recording-item/audio-recording-item.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAudioRecordingItem',
  props: {
    audioLevels: {},
    duration: {},
    status: {},
    playbackPosition: {},
    isPlaying: { type: Boolean },
    enhanced: { type: Boolean }
  },
  emits: ["status-toggle"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onStatusToggle: (event: CustomEvent<{isPlaying: boolean}>) => emit('status-toggle', event as CustomEvent<{isPlaying: boolean}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-audio-recording-item',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})